import Cookies from "js-cookie";
import { create, update, getById } from "@/api/shopping-cart";

const KEY_SHOPPING_CART_ID = "kingdynasty_ec_shopping_cart_id";

const getDefaultState = () => ({
  shoppingCartId: Cookies.get(KEY_SHOPPING_CART_ID),
  shoppingCart: {}
});

const state = getDefaultState();

const mutations = {
  SET_SHOPPING_CART_ID: (state, shoppingCartId) => {
    state.shoppingCartId = shoppingCartId;
  },
  SET_SHOPPING_CART: (state, shoppingCart) => {
    state.shoppingCart = shoppingCart;
  }
};

const actions = {
  async createShoppingCart({ commit }) {
    const shoppingCart = await create();
    const shoppingCartId = shoppingCart._id;
    Cookies.set(KEY_SHOPPING_CART_ID, shoppingCartId);
    commit("SET_SHOPPING_CART_ID", shoppingCartId);
    commit("SET_SHOPPING_CART", shoppingCart);
  },
  async updateShoppingCart({ commit }, data) {
    commit("SET_SHOPPING_CART", await update(state.shoppingCartId, data));
  },
  async clearShoppingCart({ commit }) {
    commit("SET_SHOPPING_CART", await update(state.shoppingCartId, { lineItems: [] }));
  },
  async loadShoppingCart({ commit }) {
    commit("SET_SHOPPING_CART_ID", Cookies.get(KEY_SHOPPING_CART_ID));
    commit("SET_SHOPPING_CART", await getById(state.shoppingCartId));
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}